<template>
  <div class="search-item" :style="{width:searchWidth}">
    <label class="search-label">{{searchLabel}}</label>
    <el-input class="search-input" v-model="value" :placeholder="'请输入'+searchLabel"></el-input>
  </div>
</template>
<script>
  export default {
    name: "searchInput",
    props: {
      searchLabel: {
        type: String,
        default: ''
      },
      searchWidth: {
        type: String,
        default: ''
      },
      searchValue: {
        type: String,
        default: ''
      },
    },
    data: function() {
      return {
        value: this.searchValue
      }
    },
    /* computed: {
    }, */
    methods: {
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/search/searchInput.vue